import script from "./Public.vue?vue&type=script&setup=true&lang=js"
export * from "./Public.vue?vue&type=script&setup=true&lang=js"

import "./Public.vue?vue&type=style&index=0&id=bb1a58d6&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb1a58d6"]])

export default __exports__